import logEvent from "app/assets/javascripts/tracking/amplitude/log-event"
import scribdAuthorize from "../../scribd/scribd_oauth.js"
import { trapFocus } from "app/assets/javascripts/utils/accessibility"

const DESCRIPTION_MAX_HEIGHT = 110

$(function () {
  "use strict"
  const slideshare_object = window.slideshare_object
  const utils = window.slideshare_object.utils
  let changeFocusOrderToChildNum
  let exitPromoLogged = false

  function logEventToAmplitude(eventName) {
    const slideshow = slideshare_object.slideshow
    const eventOptions = {
      slideshow_id: slideshow.id,
      slideshow_created_at: slideshow.created_at,
      slideshow_category: slideshare_object.gam_cat_name,
      slideshow_language: slideshow.language,
      slideshow_format: slideshow.type,
      source: "slideshow_view",
    }
    logEvent(eventName, eventOptions)
  }

  function modifiedFocusTrappingLikesModal(e, domElement) {
    const elementsToFocus = $(
      "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])"
    )
    const focusableEls = domElement.find(elementsToFocus).filter(":visible")
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9
    const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      /* shift + tab */
      if (changeFocusOrderToChildNum && $(e.target).hasClass("j-more-favs")) {
        $(`.likes-row-${changeFocusOrderToChildNum - 1}`).focus()
        changeFocusOrderToChildNum = 0
        e.preventDefault()
      }

      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus()
        e.preventDefault()
      }
    } else {
      /* tab */
      if (changeFocusOrderToChildNum && $(e.target).hasClass("j-more-favs")) {
        $(`.likes-row-${changeFocusOrderToChildNum}`).focus()
        changeFocusOrderToChildNum = 0
        e.preventDefault()
      } else if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus()
        e.preventDefault()
      }
    }
  }

  function handleReport(e) {
    if (!utils.isUserAuthenticated()) {
      e.preventDefault()
      e.stopPropagation()
      /**
       * Edge Case Handling: Report is the only action that does not use
       * addAfterLoginEvent, if the user clicks like/follow person, category,
       * comment, clip & click back from Scribd Oauth page, we want to clear
       * the cookie that is set to execute afterLoginEvent
       */
      if (window.cookie("after_login_action") !== null) {
        window.cookie("after_login_action", "", { path: "/", "max-age": -1 })
      }
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshare_object.slideshow.id })
    } else {
      $("#report-slideshow-modal").removeClass("hidden")
      $("#report-slideshow-modal .close").focus()
      $("body").addClass("no_scroll")
      $(".tos-update-banner, #main-nav, .wrapper").attr("aria-hidden", true)

      $("#report-slideshow-modal").on("keydown", (event) => {
        trapFocus(event, $("#report-slideshow-modal"))
      })
    }
  }

  function handleOpenLikesInfoModal() {
    $("#slideshow-likes-modal").removeClass("hidden")
    $("#slideshow-likes-modal .close").focus()
    $("body").addClass("no_scroll")
    $(".tos-update-banner, #main-nav, .wrapper").attr("aria-hidden", true)

    $("#slideshow-likes-modal").on("keydown", (e) => {
      modifiedFocusTrappingLikesModal(e, $("#slideshow-likes-modal"))
    })
  }

  function updateLikeCount(value) {
    let $counter = $(".j-like-count")
    for (let i = 0; i < $counter.length; i++) {
      const counterElem = $($counter[i])
      let newCount = parseInt(counterElem.attr("data-favorites-count"), 10) + value
      let populateFavoritesCountOnly = counterElem.attr("data-populate-favorites-count-only")

      counterElem.attr("data-favorites-count", newCount)
      if (populateFavoritesCountOnly === "true") {
        counterElem.text(newCount)
      } else {
        counterElem.text(utils.i18n("slideshow.foundation_slideview.likes_count", [{ count: newCount }]))
      }
    }
  }

  function getPostDataForLike() {
    return {
      slideshow_id: slideshare_object.presentationId,
      user_id: slideshare_object.user.id,
      source: "slideviewer",
    }
  }

  function saveSlideshowUnlike() {
    $.post(slideshare_object.favorites.delete_url, getPostDataForLike()).then(function () {
      $(".j-like-button")
        .removeClass("liked")
        .attr("data-action", "like")
        .children("i")
        .removeClass("icon-heart-filled")
        .addClass("icon-heart")
      updateLikeCount(-1)
      logEventToAmplitude("slideshow_unliked")
    })
  }

  function saveSlideshowLike() {
    $.post(slideshare_object.favorites.create_url, getPostDataForLike()).then(function () {
      $(".j-like-button")
        .addClass("liked")
        .attr("data-action", "unlike")
        .children("i")
        .removeClass("icon-heart")
        .addClass("icon-heart-filled")
      updateLikeCount(1)
      logEventToAmplitude("slideshow_liked")
    })
  }

  function handleLike() {
    const dataAction = $(".j-like-button").attr("data-action")

    if (utils.isUserAuthenticated()) {
      if (dataAction === "like") {
        saveSlideshowLike()
      } else if (dataAction === "unlike") {
        saveSlideshowUnlike()
      }
    } else {
      let eventConfig = {
        event: "like",
        data: { slideshow_id: slideshare_object.slideshow.id },
      }
      slideshare_object.addAfterLoginEvent(eventConfig)
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshare_object.slideshow.id })
    }
  }

  function handleCloseReportSlideshowModal() {
    $("#report-slideshow-modal").addClass("hidden")
    $("body").removeClass("no_scroll")
    $(".tos-update-banner, #main-nav, .wrapper").removeAttr("aria-hidden")
    $(".more-options-dropdown-trigger").focus()
  }

  function handleCloseLikesSlideshowModal() {
    $("#slideshow-likes-modal").addClass("hidden")
    $("body").removeClass("no_scroll")
    $(".tos-update-banner, #main-nav, .wrapper").removeAttr("aria-hidden")
    $(".slideshow-likes-modal-trigger").focus()
  }

  function handleCloseViewsSlideshowModal() {
    $("#slideshow-views-modal").addClass("hidden")
    $("body").removeClass("no_scroll")
    $(".tos-update-banner, #main-nav, .wrapper").removeAttr("aria-hidden")
    $(".slideshow-views-modal-trigger").focus()
  }

  function handleExpandSlideshowDescription() {
    $(".fade-slideshow-description").addClass("hidden")
    $(".js-expand-description").addClass("hidden")
    $(".slideshow-description-text-wrapper").removeClass("truncated")
  }

  function handleOpenSubscriptionLearnMoreModal() {
    $("#subscription-success-learn-more-modal").removeClass("hidden")
    $("#subscription-success-learn-more-modal .close").focus()
    $("body").addClass("no_scroll")

    $(".tos-update-banner, #main-nav, .wrapper").attr("aria-hidden", true)

    $("#subscription-success-learn-more-modal").on("keydown", (event) => {
      trapFocus(event, $("#subscription-success-learn-more-modal"))
    })
  }

  function handleCloseSubscriptionLearnMoreModal() {
    $("#subscription-success-learn-more-modal").addClass("hidden")
    $("body").removeClass("no_scroll")
    $(".tos-update-banner, #main-nav, .wrapper").removeAttr("aria-hidden")
    $(".subscription-success-notification .learn-more-link").focus()
  }

  function handleCloseSubscriptionSuccessNotification() {
    $(".subscription-success-notification").addClass("hidden")
  }

  function createElementWithClass(node, className) {
    const element = document.createElement(node)
    element.setAttribute("class", className)
    return element
  }

  function createNodeWithAttributes(node, attributes) {
    const element = document.createElement(node)
    for (let key in attributes) {
      element.setAttribute(key, attributes[key])
    }
    return element
  }

  function checkAndAppendText(text, element) {
    if (text) {
      element.appendChild(document.createTextNode(text))
    }
  }

  function handleAddMoreFavorites() {
    const { total, url } = slideshare_object.activities.favorites
    let favoritesUrl = url

    const favoritesContainer = $("#favs-list")
    const favoritesRows = $(".likes-row")
    const offset_param = "offset=" + favoritesRows.length

    if (favoritesUrl.indexOf("?") >= 0) {
      favoritesUrl += "&" + offset_param
    } else {
      favoritesUrl += "?" + offset_param
    }

    fetch(favoritesUrl, { method: "GET" })
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          return response.json().then((result) => {
            return Promise.reject({ status: result.status, message: "Please try again in sometime." })
          })
        }
      })
      .then((data) => {
        const docFragment = data.reduce((accum, favItem, currentIndex) => {
          const offsetLikesRowNum = favoritesRows.length + currentIndex
          const likesRowListItem = document.createElement("li")
          const likesRowAnchor = createNodeWithAttributes("a", {
            class: `likes-row likes-row-${offsetLikesRowNum}`,
            href: `/${favItem.login}?utm_campaign=profiletracking&utm_medium=sssite&utm_source=ssslideshow`,
          })
          const authorPhotoContainer = createElementWithClass("div", "author-photo-thumbnail")
          const lazyLoadThumbImg = createNodeWithAttributes("img", {
            class: "lazy-thumb-img",
            alt: "",
            src: favItem.photo,
            "data-original": favItem.photo,
          })
          const authorInfoContainer = createElementWithClass("div", "author-info")
          const usernameTimeDiv = createElementWithClass("div", "username-time")
          const usernameSpan = createElementWithClass("span", "username")
          checkAndAppendText(favItem.user_name, usernameSpan)
          const favtimeSpan = createElementWithClass("span", "liked-time")
          checkAndAppendText(favItem.summary, favtimeSpan)
          const userInfoDiv = createElementWithClass("div", "user-info")
          const favoriterRoleSpan = createElementWithClass("span", "favoriter-role")
          checkAndAppendText(favItem.user_occupation, favoriterRoleSpan)
          const favoriterOrgSpan = createElementWithClass("span", "favoriter-org")
          favoriterOrgSpan.appendChild(document.createTextNode(favItem.user_organization))
          checkAndAppendText(favItem.user_organization, favoriterOrgSpan)

          authorPhotoContainer.appendChild(lazyLoadThumbImg)
          usernameTimeDiv.appendChild(usernameSpan)
          usernameTimeDiv.appendChild(favtimeSpan)
          userInfoDiv.appendChild(favoriterRoleSpan)
          userInfoDiv.appendChild(favoriterOrgSpan)
          authorInfoContainer.appendChild(usernameTimeDiv)
          authorInfoContainer.appendChild(userInfoDiv)

          likesRowAnchor.appendChild(authorPhotoContainer)
          likesRowAnchor.appendChild(authorInfoContainer)

          likesRowListItem.appendChild(likesRowAnchor)

          accum.appendChild(likesRowListItem)
          return accum
        }, document.createDocumentFragment())
        changeFocusOrderToChildNum = $(".likes-row").length
        favoritesContainer.append(docFragment)

        if ($(".likes-row").length === total) {
          $(`.likes-row-${changeFocusOrderToChildNum}`).focus()
          $(".more-container").hide()
        }
      })
      .catch(() => {
        throw new Error("Error fetching more favorites information")
      })
  }

  function dismissAd() {
    logEventToAmplitude("exit_promo_dismissed")
    $.cookie("scribd_ad_exit_slideshow_page", true, { path: "/", expires: 1 })
    $("#scribd-ad-exit-modal").addClass("hidden")
  }

  $(".j-like-button").on("click", handleLike)

  $(".slideshow-likes-modal-trigger").on("click", handleOpenLikesInfoModal)
  $("#slideshow-likes-modal .close").on("click", handleCloseLikesSlideshowModal)
  $("#slideshow-likes-modal .mobile-back-button").on("click", handleCloseLikesSlideshowModal)
  $("#slideshow-likes-modal-backdrop").on("click", handleCloseLikesSlideshowModal)

  $("#slideshow-views-modal .close").on("click", handleCloseViewsSlideshowModal)
  $("#slideshow-views-modal .mobile-back-button").on("click", handleCloseViewsSlideshowModal)
  $("#slideshow-views-modal-backdrop").on("click", handleCloseViewsSlideshowModal)

  $(".report").on("click", handleReport)
  $("#report-slideshow-modal .close").on("click", handleCloseReportSlideshowModal)
  $("#report-slideshow-modal-backdrop").on("click", handleCloseReportSlideshowModal)

  $(".js-expand-description").on("click", handleExpandSlideshowDescription)
  $(".j-more-favs").on("click", handleAddMoreFavorites)

  $(".subscription-success-notification .learn-more-link").on("click", handleOpenSubscriptionLearnMoreModal)
  $("#subscription-success-learn-more-modal .close").on("click", handleCloseSubscriptionLearnMoreModal)
  $("#subscription-success-learn-more-modal-backdrop").on("click", handleCloseSubscriptionLearnMoreModal)

  $(".subscription-success-notification .close").on("click", handleCloseSubscriptionSuccessNotification)

  $("#scribd-ad-exit-backdrop").on("click", dismissAd)
  $("#scribd-ad-exit-modal .close").on("click", dismissAd)

  $("#scribd-ad-exit-modal .cta").on("click", function () {
    logEventToAmplitude("exit_promo_cta_clicked")
    $.cookie("scribd_ad_exit_slideshow_page", true, { path: "/", expires: 365 })
    $("#scribd-ad-exit-modal").addClass("hidden")
  })

  $(document).on("mouseleave", function () {
    const exitAdCookie = $.cookie("scribd_ad_exit_slideshow_page")

    if (!exitAdCookie) {
      if (!exitPromoLogged) {
        logEventToAmplitude("exit_promo_shown")
        exitPromoLogged = true
      }

      $("#scribd-ad-exit-modal").removeClass("hidden")
      $("#scribd-ad-exit-modal .close").focus()
      $(".tos-update-banner, #main-nav, .wrapper").attr("aria-hidden", true)

      $("#scribd-ad-exit-modal").on("keydown", (e) => {
        trapFocus(e, $("#scribd-ad-exit-modal"))
      })
    }
  })

  $(document).on("keyup", function (event) {
    const KEYCODE_ESCAPE = 27
    // Keyboard users should be able to close dialog by pressing escape key
    if (event.key === "Escape" || event.keyCode === KEYCODE_ESCAPE) {
      if ($("#scribd-ad-exit-modal").is(":visible")) {
        dismissAd()
      }
      if ($("#slideshow-likes-modal").is(":visible")) {
        handleCloseLikesSlideshowModal()
      }
      if ($("#slideshow-views-modal").is(":visible")) {
        handleCloseViewsSlideshowModal()
      }
      if ($("#report-slideshow-modal").is(":visible")) {
        handleCloseReportSlideshowModal()
      }
      if ($("#subscription-success-learn-more-modal").is(":visible")) {
        handleCloseSubscriptionLearnMoreModal()
      }
    }
  })
})

function handleDescriptionReadMore() {
  const mobileDescriptionHeight = $(".slideshow-information.mobile .slideshow-description-text").height()
  const desktopDescriptionHeight = $(".slideshow-information.desktop .slideshow-description-text").height()

  if (mobileDescriptionHeight > DESCRIPTION_MAX_HEIGHT) {
    $(".slideshow-information.mobile .js-expand-description").removeClass("hidden")
    $(".slideshow-information.mobile .fade-slideshow-description").removeClass("hidden")
    $(".slideshow-information.mobile .slideshow-description-text-wrapper").addClass("truncated")
  } else if (desktopDescriptionHeight > DESCRIPTION_MAX_HEIGHT) {
    $(".slideshow-information.desktop .js-expand-description").removeClass("hidden")
    $(".slideshow-information.desktop .fade-slideshow-description").removeClass("hidden")
    $(".slideshow-information.desktop .slideshow-description-text-wrapper").addClass("truncated")
  }
}

window.addEventListener("DOMContentLoaded", () => {
  handleDescriptionReadMore()
})
